import { render } from "./Header.vue?vue&type=template&id=be391e90"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=be391e90&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__